import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    backgroundContainer: {
        height: "100vh",
        background: theme.palette.backgrounds.main,
        display: "flex",
        flexDirection: "column",
        paddingTop: theme.spacing(17),
    },
    headerContainer: {
        width: "95%",
        display: "flex",
        flexDirection: "column",
        margin: "10px auto",
    },
    title: {
        "&.MuiTypography-root": {
            fontFamily: "Source Sans 3",
            textAlign: "left",
            fontWeight: 400,
            fontSize: "24px",
            color: theme.palette.secondary.dark,
            display: "flex",
            justifyContent: "space-between",
        },
    },
    titleContainer: {
        display: "flex",
        justifyContent: "flex-start",
        width: "100%",
    },
    tabsContainer: {
        width: "95%",
        margin: "0 auto",
    },
    tabs: {
        "&.MuiTabs-root .MuiTabs-scroller .MuiTabs-indicator": {
            borderBottom: "none",
            backgroundColor: "transparent",
        },
        "&.MuiTabs-root .MuiTabs-scroller .MuiTabs-flexContainer .MuiButtonBase-root": {
            fontFamily: "Source Sans 3",
            fontWeight: 400,
            fontSize: "14px",
            color: theme.palette.corporateBO.tabText,
            textTransform: "none",
            padding: 0,
        },
        "&.MuiTabs-root .MuiTabs-scroller .MuiTabs-flexContainer .Mui-selected": {
            fontFamily: "Source Sans 3",
            fontWeight: 600,
            fontSize: "14px",
            color: theme.palette.corporateBO.tabText,
            textTransform: "none",
            borderBottom: `3px solid ${theme.palette.border.tabs}`,
        },
        "&.MuiTabs-root .MuiTabs-scroller .MuiTabs-flexContainer": {
            gap: theme.spacing(6),
        },
    },
    backButton: {
        "&.MuiButtonBase-root": {
            fontFamily: "Source Sans 3",
            fontWeight: 400,
            fontSize: "12px",
            color: theme.palette.text.primary,
            padding: 0,
            textTransform: "uppercase",
        },
        "&.MuiButtonBase-root .MuiSvgIcon-root": {
            fontSize: "12px",
        },
    },
    editButton: {
        "&.MuiButtonBase-root .MuiSvgIcon-root": {
            height: "20px",
        },
    },
    tooltip: {
        "&.MuiTooltip-popper .MuiTooltip-tooltip": {
            backgroundColor: theme.palette.secondary.main,
        },
    },
    tooltipTexts: {
        "&.MuiTypography-root": {
            fontSize: "14px",
            textAlign: "left",
            color: theme.palette.text.primary,
            fontWeight: 600,
            fontFamily: "Source Sans 3",
            paddingBottom: "5px",
        },
    },
}));
